import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from '../../../tableSettings';
import {
  DateRenderer,DateTimeRenderer, FloatRenderer, TextAlignLeftWithAddressTooltipRenderer,
  NullableCheckboxIconRenderer, TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer
} from "../../common/AbstractListView";
import {Search} from '../../../filtering';
import {airImportHawbList} from '../tableSettings';
import {JobNames} from '../../../framework.core/JobNames';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import {useHistory} from 'react-router';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import ApplicationContext from '../../../ApplicationContext';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import loadInfoAreaInvoiceBillCrDb from '../../../components/common/InfoAreaInvoiceBillCrDb';
import {AiHblListItem, AihListType} from '../../../fms.data/models/AiHblListItem';
import BlackInverseButton from "../../../ui/BlackInverseButton";
import IfmsModal from "../../../ui/IfmsModal";
import HawbMilestonePopup from "./HawbMilestonePopup";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import {ReactComponent as ContainerTrackingIcon} from "../../../img/container_tracking.svg";
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer } from '../../common/commonListRenderers';
import * as XCol from '../../../framework.core/XExportColumn';
import DeleteHistory from "../../reports/DeleteHistory";
import postal from 'postal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import RecogModal from '../../../ui/RecogModal';
import constants from '../../../constants';
import { formatShipmentType } from '../../common/utils/formatUtils';

function useHawbOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToMawbFor(hawb: AiHblListItem | null) {
    if (!hawb) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/aiMawb/airImport', 
    'id', 'Ref. #', hawb.aiMblId, 'updated', false, true, null, 'refNo', hawb.refNo, false,true);
    openNewPage(history, `/common/joblistview/aiMawb/airImport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(hbl:AiHblListItem|null) {
    if (!hbl) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.AIHbl}/${hbl.id}`, NavigationType.newPage);
  }

  return {switchToMawbFor, switchToAcctInfo};
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useHawbOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function useSelectedHawbOperation() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const { switchToMawbFor } = useHawbOperations();

  const selectedElement = jobListContext.selectedElement as AiHblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const setSavedEntityAim = useSetEditedId([JobNames.AIMbl]);

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/airImport/hawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const openedByF6 = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/common/joblistview/aiMawb/airImport';

    const openedByMaster = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/airImport/mawb/edit/' + jobListContext.f6Query;  

    const newUrl = openedByF6 || openedByMaster
      ? `/airImport/hawb/add?mawbRefId=${jobListContext.f6Query}`
      : '/airImport/hawb/add';

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  async function deleteHbl() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close HAWB first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/AIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/AIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/AIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/AIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/AIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/AIHB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.',false,null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.AIHbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
        setSavedEntityAim(selectedElement.aiMblId?.toString(), false);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');  
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/airImport/hawb/edit/${id}`;
    const viewUrl = `/airImport/hawb/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/airImport/hawb/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/airImport/viewBillings/hawb/${id}`;
  
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.AIHbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function viewProfit(viewEdit:boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/airImport/hawb/edit/${id}`;
    const viewUrl = `/airImport/hawb/view/${id}`;

    let editUrlProfitTab = `${editUrl}/4`;
    let viewUrlProfitTab = `${viewUrl}/4`;

    if (viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/airImport/hawb/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab , [viewUrl, editUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const editUrl = `/airImport/hawb/edit/${id}`;
    const viewUrl = `/airImport/hawb/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.AIHbl);

    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/airImport/hawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/airImport/hawb/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToMawb() {
    const selectedElement = jobListContext.selectedElement as AiHblListItem;
    switchToMawbFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return { create, deleteHbl, edit, view, copy, switchToMawb, recognize, viewBillings, moveToDeleteHistoryReport, viewProfit, setSavedEntityAim };
}

function HawbListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.AIHbl);

  const { copy, create, edit, view, switchToMawb, viewBillings, viewProfit } = useSelectedHawbOperation();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToMawb();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    }  else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `HAWB #: ${(jobListContext.selectedElement as AiHblListItem|null)?.hawbNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.AIHbl}
      jobId={(jobListContext.selectedElement as AiHblListItem|null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function HawbListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteHbl, edit, view, copy, switchToMawb, recognize, viewBillings, viewProfit } = useSelectedHawbOperation();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AiHblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.AIHbl);
  const fmsGlobal = getFmsGlobal();

  function openBLStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.AIHbl, selectedElement.id, !(selectedElement as any).isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/edit/${selectedElement.id}`)) {
      const editModelKey = `editAiHawb${selectedElement.id}-/airImport/hawb/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }
  
  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to MAWB List', shortcut: 'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    { label: 'HAWB Status Update', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize },
  ];

  const itemStatus = [
    { label: !selectedElement?.isClosed ? 'File Lock' : 'Unlock', shortcut: '', separator: false, hidden: !showFileLock },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="aih-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));
  
  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteHbl();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToMawb();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        viewBillings();
        break;
      case 9:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      case 10:
        openBLStatus();
        break;
      case 11:
        processFileLock();
        break;
      case 12:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

//#1607
// function AfterMemoLogButtonCommands() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as AiHblListItem;

//   return (
//     <>
//       &nbsp;&nbsp;
//       <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
//         onClick={() => window.open(`http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mawbNo}`)}>
//         <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
//       </BlackInverseButton>
//     </>
//   )
// }

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AiHblListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalOP && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.AIHbl, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function HawbListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as AiHblListItem;
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);

  const { deleteHbl, edit, view, copy, viewBillings, moveToDeleteHistoryReport, setSavedEntityAim } = useSelectedHawbOperation();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  
  // function hasOpenedViewOrEditFor(id:number) {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/view/${id}`);
  // }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/add`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAim(selectedElement.aiMblId?.toString(), false);
    setSavedEntityJournal('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.AIHbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/view/${id}`);
  }

  const allowedStatuses = ['', 'E', 'D'];
  
  const listSec = findSecurityTask(appContext, FmsSecTask.AIHbl);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const openedByF6 = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/common/joblistview/aiMawb/airImport';

  const openedByMaster = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/airImport/mawb/edit/' + jobListContext.f6Query;

  const newUrl = openedByF6 || openedByMaster
    ? `/airImport/hawb/add?mawbRefId=${jobListContext.f6Query}`
    : '/airImport/hawb/add';

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name ='aih-list-add-button' display="primary" size="regular" link={newUrl} disabled={!canBeAdd} label="New" />&nbsp;
        <PrimaryButton name ='aih-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name ='aih-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name ='aih-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteHbl}> Delete</PrimaryButton>&nbsp;
        <PrimaryButton name ='aih-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton name ='aih-list-viewBillings-button' size="regular" onClick={viewBillings}>{constants.List_Billings}</PrimaryButton>&nbsp;
        <PrimaryButton name='aih-list-deleteHistory-button' size="regular" onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>
      </div>
      {/* <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
         <ActionButton
          type="primary"
          // height="800px"
          variant="plain"
          onItemSelected={(event) => setSelectedPopupMenuItem(event)}
          items={[
            { label: 'Arrival Notice', separator: false, popupComponent: <HblArrivalNotice selectedElement={selectedElement} jobName={JobNames.AIHbl} />, popupLabel: 'Arrival Notice (HAWB)' },
            { label: 'Authority to Make Entry', separator: false, subMenu: FmsSubMenu.AuthEntry },
            { label: 'Correction Notice/Request', separator: false, popupComponent: <CorrectionNotice jobName={JobNames.AIHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Delivery Order (Pre Form)', separator: false, popupComponent: <DeliveryOrder jobName={JobNames.AIHbl} selectedElement={selectedElement} docType={DocumentType.DO} /> },
            { label: 'Delivery Order (Short Form)', separator: false, popupComponent: <DeliveryOrder jobName={JobNames.AIHbl} selectedElement={selectedElement} docType={DocumentType.DeliveryOrderShort} /> },
            { label: 'Pickup/Delivery Instruction', separator: true, popupComponent: <PickupDelivery jobName={JobNames.AIHbl} docType={DocumentType.Pickup} selectedElementId={selectedElement?.id} /> },
            { label: 'Est. Profit', separator: true, subMenu: FmsSubMenu.HouseProfit },
            { label: 'Cargo Status Query', separator: true, newCol: true, popupComponent: <CargoManifestStatus selectedElement={selectedElement} jobName={JobNames.AIHbl} /> },
            //{ label: 'Go to Carrier\'s Tracking', separator: true, newCol: true, link: 'http://dotnet.freightstream.com/fsutil/customs.asp?mbn=' + selectedElement?.mawbNo },
            { label: 'Carrier\'s Certificate', separator: false, subMenu: FmsSubMenu.CarrierCertificate },
            { label: 'Export Declaration for Transit', separator: false, subMenu: FmsSubMenu.ExdecTransit},
            { label: 'Print 7512', separator: false, popupComponent: <ItTeNotice jobName={JobNames.AIHbl} selectedElement={selectedElement} /> },
            { label: 'Memo List', separator: false, popupComponent: <MemoList selectedElement={selectedElement} jobName={JobNames.AIHbl} />, popupLabel: 'Memo List (HAWB)' },
            { label: 'Memo List (Customer)', separator: false, popupComponent: <MemoList selectedElement={selectedElement} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)' },
            { label: 'Package Label', separator: false, popupComponent: <PackageLabel jobName={JobNames.AIHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Preliminary Claim Notice', separator: false, popupComponent: <PreliminaryClaimNotice jobName={JobNames.AIHbl} selectedElement={selectedElement} /> },
            { label: 'Proof of Delivery', separator: false, popupComponent: <ProofOfDelivery selectedElement={selectedElement} jobName={JobNames.AIHbl} />, popupWidth: 790 },
            { label: 'Release Order/Turnover', separator: false, popupComponent: <ReleaseOrderTurnover jobName={JobNames.AIHbl} selectedElementId={selectedElement?.id} />  },
            { label: 'Straight B/L', separator: true, popupComponent: <StraightBl jobName={JobNames.AIHbl} selectedElementId={selectedElement?.id} /> },

            // { label: 'Copy to CFS', separator: true },
          ]}
        >
          More Menu
        </ActionButton>
        &nbsp;
        <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
          onClick={() => setSelectedPopupMenuItem({ label: 'Go to Carrier\'s Tracking', link: `http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mawbNo}` })}>
          <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
        </BlackInverseButton>
      </div> */}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.aiMblId} mTbName={"T_AIMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function formatData(data:Array<AiHblListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

/**
 * Concrete implementation for AI HAWB List screen
 *
 * @class HawbListView
 * @extends {AbstractListView}
 */
 class HawbListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = airImportHawbList;
    const useBranch = systemSettings?.enableBranch ?? false;
    
    let cols: XCol.XExportColumn[] = [];
    if (this.systemSettings?.isCanada) {
      cols = AiHblListItem.getExportCollection(AihListType.NormalCan, useBranch);
    }
    else if (this.systemSettings?.showMilestoneInAihList) {
      cols = AiHblListItem.getExportCollection(AihListType.HblInfo, useBranch);
    }
    else {
      cols = AiHblListItem.getExportCollection(AihListType.Normal, useBranch);
    }

    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  getTableDomIdSuffix(): string {
    return this.systemSettings?.showMilestoneInAihList ? 'milestone' : '';
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'updateDate',
      orderByAscending: false,
    };
  }
  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }
  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const lType = this.systemSettings?.showMilestoneInAihList ? AihListType.NormalCan : AihListType.Normal;
    const useBranch = systemSettings?.enableBranch ?? false;
    return AiHblListItem.getExportCollection(lType, useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if(x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      else if (x.dataIndex === 'recognized') {
          colRenderer.Cell = RecognizedRenderer;
      }
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if (x.dataIndex === 'p') colRenderer.Cell = PaidRenderer;
      else if (x.dataIndex === 'shipperName' || x.dataIndex === 'consigneeName' || x.dataIndex === 'notifyName') colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
   }

   getExportRenderers(): ExportRowRenderer[] {
     const colRenderer = [];
     colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
     colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
     colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
     return colRenderer;
   }

  async fetchAndFormatData(api: any, search: Search, opType: string): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AIHbl,
      'AiHblListItem',
      AiHblListItem.calculateSearchParameters(search, AiHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      1,
      search.pageSize,
      );

      if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
        return {data: [], totalCount: 0};
      }
  
      return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }
  renderCommands(): React.ReactNode {
    return (
      <HawbListCommands />
    );
  }
  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <HawbListToolbar />
    );
  }
  renderAfterConfigureButton(): React.ReactNode {
    return <></>
  }
  
  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return <HawbListViewExtras hideLogHistory={hideLogHistory} />
  }
  public renderInsideTopRightOpMenu(): React.ReactNode {
    return (
      <BlackInverseButton size="large" data-tooltip="Container Tracking" >
        <ContainerTrackingIcon width={20} height={20} />
      </BlackInverseButton>
    );
  }
  getViewUrlFor(row: any): string {
    return row && row.id ? `/airImport/hawb/view/${row.id}` : '';
  }
  getListViewTitle(): string {
    return 'HAWB List';
  }
  
  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AIHbl} keyProp='id' showAdjustBalance={false} showFixJournal={false} />;
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext): React.ReactNode|null {
    if (!rowId) {
      return null;
    }
    const storageKey = `ai-hbl-milestone-${rowId}`;
    const storageStatusKey = `ai-hbl-status-milestone-${rowId}`;

    function onClose() {
      // fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="HAWB Status Update" width="760px">
        <HawbMilestonePopup hawbId={rowId} statusStorageKey={storageStatusKey} storageKey={storageKey} onClose={onClose} isView={false} />
      </IfmsModal>
    );
  }
  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    //#1607
    // return <AfterMemoLogButtonCommands />
    return null;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default HawbListView;
